var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKr = function SvgKr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e1aff7d5-75ae-40fe-a3d4-5a8b8f3edfe3a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b38b929b-b837-4828-8f04-51c85a7ee84db",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b38b929b-b837-4828-8f04-51c85a7ee84db)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0048AB",
    fillRule: "evenodd",
    d: "M14 7.5a3.5 3.5 0 1 1-7 0c0-1.12 2.35-1.59 4.328-1.413A2.6 2.6 0 0 1 12 6c1.105 0 2 .672 2 1.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD0027",
    fillRule: "evenodd",
    d: "M10 7s.895-1 2-1 2 .672 2 1.5a3.5 3.5 0 0 0-6.664-1.498C7 7 7 7.292 7 7.5c.5.5 1.056.5 1.5.5s.843-.193 1.118-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252526",
    fillRule: "evenodd",
    d: "M15 5h2l-2-2h-1zM6 5H4l2-2h1zm9 5h2l-2 2h-1zm-9 0H4l2 2h1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e1aff7d5-75ae-40fe-a3d4-5a8b8f3edfe3a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgKr;